export default "__VITE_PUBLIC_ASSET__578b009f__"